import { Stack } from "@mantine/core";
import UnsubsContent from "./UnsubsContent";
import { Navigate, useParams } from "react-router-dom";

const RightWrapperUnsubs = () => {
  const { orgId } = useParams();

  if (orgId === "none") {
    return <Navigate to={"/unsubscribers/all"} replace />;
  }

  return (
    <Stack h={"100%"} pos={"relative"} flex={1}>
      <UnsubsContent
        listId={orgId}
      />
    </Stack>
  );
};

export default RightWrapperUnsubs;
